import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IDistributionTaskSummaryRequest, IDistributionTaskSummaryDetail, IDistributionTaskAgentRequest, IDistributionTaskAgentDetail, IDistributionTaskCompanyDetail } from '@core/main/types/report/report-center';
import { IAgentOptionsItem, IServerOptionsItem } from '@core/main/types';
const hostUrl = getHostbaseUrl();

/**
 * 分润汇总表分页查询
 */
export async function queryDistributionTaskSummaryPage(param: IDistributionTaskSummaryRequest) {
  let data = [] as IDistributionTaskSummaryDetail[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IDistributionTaskSummaryDetail[]; total: number }>(`${hostUrl}/report/crowd/distributionTask/summary/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IDistributionTaskSummaryDetail[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 汇总表分页导出
 */
export async function exportDistributionTaskSummary(param: IDistributionTaskSummaryRequest) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/report/crowd/distributionTask/summary/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 分润特代维度表分页查询
 */
export async function queryDistributionTaskAgentPage(param: IDistributionTaskAgentRequest) {
  let data = [] as IDistributionTaskAgentDetail[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IDistributionTaskAgentDetail[]; total: number }>(`${hostUrl}/report/crowd/distributionTask/agent/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IDistributionTaskAgentDetail[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 特代维度表分页导出
 */
export async function exportDistributionTaskAgent(param: IDistributionTaskAgentRequest) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/report/crowd/distributionTask/agent/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 分润企业维度表分页查询
 */
export async function queryDistributionTaskCompanyPage(param: IDistributionTaskAgentRequest) {
  let data = [] as IDistributionTaskCompanyDetail[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IDistributionTaskCompanyDetail[]; total: number }>(`${hostUrl}/report/crowd/distributionTask/company/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IDistributionTaskCompanyDetail[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 企业维度表分页导出
 */
export async function exportDistributionTaskCompany(param: IDistributionTaskAgentRequest) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/report/crowd/distributionTask/company/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 查询有报表的代理商
 */
export async function queryAgentListForAllReport() {
  let data = [] as IAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IAgentOptionsItem>>(`${hostUrl}/report/crowd/side/summary/agent/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 查询有报表的服务商
 */
export async function queryServerListForAllReport() {
  let data = [] as IServerOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IServerOptionsItem>>(`${hostUrl}/report/crowd/side/summary/server/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 查询有报表的代理商 其他维度
 */
export async function queryAgentListForOtherReport() {
  let data = [] as IAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IAgentOptionsItem>>(`${hostUrl}/report/crowd/side/report/agent/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 查询有报表的服务商  其他维度
 */
export async function queryServerListForOtherReport() {
  let data = [] as IServerOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IServerOptionsItem>>(`${hostUrl}/report/crowd/side/report/server/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 查询有报表的企业
 */
export async function getAllCompanyListForReport() {

  let data = [];

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/report/crowd/side/report/company/list`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };

}